<template>
  <div class="box">
    <h4 class="title is-4">Giving Summary</h4>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in data_giving_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
    </table>
    <h4 class="title is-4">Event Summary</h4>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th class="has-text-centered" rowspan="3"></th>
        <th class="has-text-centered" colspan="3">Ticket Complimentary</th>
        <th class="has-text-centered" colspan="8">Ticket Penjualan</th>
      </tr>
      <tr>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" rowspan="2">Diambil</th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">Maybank</th>
        <th class="has-text-centered" colspan="2"></th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
      </tr>
      <tr>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Cash</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in data_event_list" :key="index">
        <table-row v-for="(value_row, index_value) in data_row" :key="index_value" :value-row="value_row"></table-row>
      </tr>
    </table>
    <h4 class="title is-4">Settlement</h4>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th></th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">MayBank</th>
      </tr>
      <tr>
        <th></th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
      </tr>
      <tr v-for="(data_row, index) in data_total_list" :key="index">
        <td v-for="(data_detail, index_detail) in data_row" :key="index_detail" :class="{'content-bold': data_detail.bold === 1, 'cell-grey': data_detail.color === 'grey', 'cell-green': data_detail.color === 'green'}" v-text="data_detail.total"></td>
      </tr>
      <tr>
        <td>Settlement</td>
        <td v-for="(settlement_row, index) in settlement_list" :key="index">
          <div class="control">
            <money :class="{'input': true}" v-model="settlement_list[index].value" v-bind="money"></money>
          </div>
        </td>
      </tr>
    </table>
    <div class="field is-grouped">
      <div class="control">
        <button type="button" class="button is-link" @click="getModalConfirmation('Close Counter', 'Are you sure want to close this counter?', 'close_counter')">Close Counter</button>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="submitData"></confirmation-modal>
  </div>
</template>

<script>
import {Money} from 'v-money'
import TableRow from '@/pages/panel/frontdesk/components/ReportRowEvent'
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      data_giving_list: [],
      data_event_list: [],
      data_total_list: [],
      settlement_list: [],
      selected_service: '',
      selected_counter: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'Rp. ',
        suffix: '',
        precision: 0,
        masked: false
      },
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  components: {
    TableRow,
    Money
  },
  created () {
    this.selected_service = this.getSessionItem('selected_service')
    this.selected_counter = this.getSessionItem('selected_counter')
    this.getReportGiving()
    this.getReportEvent()
    this.getReportTotal()
  },
  methods: {
    getReportGiving () {
      var self = this
      self.flyPostSession('report/my_giving_summary', {
        service: this.selected_service,
        counter: this.selected_counter
      }).then(function (response) {
        if (response.data.response_code === 1) {
          // self.header_data = response.data.data.header_data
          self.data_giving_list = response.data.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getReportEvent () {
      var self = this
      self.flyPostSession('report/my_event_summary', {
        service: this.selected_service,
        counter: this.selected_counter
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.data_event_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    getReportTotal () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('report/my_counter_summary', {
        service: this.selected_service,
        counter: this.selected_counter
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_total_list = response.data.data.data
          self.settlement_list = response.data.data.settlement
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData (confirmData) {
      if (confirmData.label === 'close_counter') {
        if (confirmData.flag === true) {
          var self = this
          self.$geb.emit({id: 'preloader', eventData: true})
          self.flyPostSession('frontdesk/close_counter', {
            service: this.selected_service,
            counter: this.selected_counter,
            settlement_list: this.settlement_list
          }).then(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            if (response.data.response_code === 1) {
              self.closeCounter()
            } else {
              var result = response.data.message
              self.errors.clear()
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
            }
          }).catch(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            self.errorMessage(response)
          })
        }
      }
      this.clearModalConfirmationData()
    },
    closeCounter () {
      this.removeSessionItem('selected_service')
      this.removeSessionItem('selected_counter')
      this.getEDCBankList()
      this.$router.push('/panel/frontdesk')
    },
    getEDCBankList () {
      var self = this
      self.flyGetSession('frontdesk/get_edc_bank')
      .then(function (response) {
        if (response.data.response_code === 1) {
          var edcBankList = response.data.data

          for (var index in edcBankList) {
            self.removeSessionItem('edc_bank_' + edcBankList[index].id)
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Close_counter.vue